import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

export const SPLASH_CONTENT = [
    {
        label: 'Hot Air Balloon',
        tag: 'Featured Projective',
        img: `${STATIC_STORAGE_URL}/img/auth-splash/splash-hotairballoon.gif`,
        content: `The Hot Air Balloon projective can be used to access prioritization of features, JTBD, benefits, etc. in consumers' minds and understand why. (Coming Soon)`,
        backgroundColor: 'bg-[#8FCCC3]'
    },

    {
        label: 'Treeman',
        tag: 'Featured Projective',
        img: `${STATIC_STORAGE_URL}/img/auth-splash/splash-treeman.gif`,
        content:
            'The Treeman projective guides participants to access and articulate how they feel about a certain topic in a very simple and effective way.',
        backgroundColor: 'bg-[#6BC5B1]'
    },
    {
        label: 'Guided Fantasy',
        tag: 'Featured Projective',
        img: `${STATIC_STORAGE_URL}/img/auth-splash/splash-guidedfantasy.gif`,
        content:
            'Through an imaginary visit to "Planet Brand X", the Guided Fantasy projective helps collect rich brand imagery and what about the brand gives people the impressions.',
        backgroundColor: 'bg-[#050505]'
    },
    {
        label: 'inca Dashboard',
        tag: 'Spotlight',
        img: `${STATIC_STORAGE_URL}/img/auth-splash/splash-dashboard.gif`,
        content:
            'inca dashboard gives you live results. Features: cross tab, sig test, filtering, weighting and many download options.',
        backgroundColor: 'bg-[#FACF5D]'
    },
    {
        label: 'Path to Purchase',
        tag: 'Spotlight',
        img: `${STATIC_STORAGE_URL}/img/auth-splash/splash-customerjourney.gif`,
        content:
            'inca scales journey mapping so you can see and size hidden opportunities by touchpoint.',
        backgroundColor: 'bg-[#FCFCFB]'
    }
    // {
    //     label: 'Happy Holidays from the inca | Nexxt Intelligence Team! ',
    //     tag: null,
    //     img: `${STATIC_STORAGE_URL}/img/auth-splash/splash-holiday.gif`,
    //     content:
    //         'Wishing you a happy, healthy holiday season and some well-deserved rest and relaxation.',
    //     backgroundColor: 'bg-[#20250E]'
    // }
];
